<!-- <app-academic-headers></app-academic-headers> -->
<!-- <div class="content"> -->
    <!-- <app-side-bar></app-side-bar> -->
    <!-- <main class="content__main"> -->
        <router-outlet></router-outlet>
    <!-- </main> -->
<!-- </div> -->

<!-- <app-academic-footers></app-academic-footers> -->
